export enum PaymentStatus {
  paymentPending = 'PEN',
  paymentProcessing = 'PRO',
  paymentComplete = 'COM',
  paymentFailed = 'FAI',
  partiallyRefunded = 'PRF',
  refunded = 'REF',
  cancelled = 'CAN'
}

export enum InvoiceStatus {
  paymentPending = 'PEN',
  depositPaid = 'DEP',
  paymentComplete = 'COM',
  partiallyRefunded = 'PRF',
  refunded = 'REF',
  cancelled = 'CAN'
}

export enum PaymentType {
  stripe = 'STR',
  gravity = 'GRA',
  mxMerchant = 'MXM',
  mock = 'MOK',
  lightspeed = 'VEN',
  square = 'SQU',
  credit = 'CRE',
  voucher = 'VOU',
  offline = 'OFF',
  posGiftCard = 'PGI',
  migrated = 'MIG',
  na = 'NA'
}

export enum PaymentTypeMixed {
  mixed = 'MIX'
}

export type PaymentTypeWithMixed = PaymentType | PaymentTypeMixed;

export enum PaymentMethodType {
  na = 'NA',
  card = 'CRD',
  bankAccount = 'BNK',
  promptPay = 'PPY',
}

export enum LineItemPurchaseType {
  booking = 'BOO',
  membershipInitial = 'MIN',
  membershipFailed = 'MFA',
  membershipRecurring = 'MRE',
  membershipPrepaidFreezeFee = 'MFR',
  membershipAddOnChangeFee = 'MAC',
  membershipUpfrontPayment = 'MUP',
  entryPass = 'EPA',
  voucherPack = 'VPO',
  /**
   * This refers to individual vouchers sold in the POS (as opposed to
   * configured voucher packs).
   */
  eventVoucher = 'EVV',
  gift = 'GIF',
  generic = 'GEN',
  legacy = 'LEG',
}
